var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRendiLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187.531,
    height: 46.332,
    viewBox: "44.961 12.303 187.531 46.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.41 31.973h26.5v19.929h-26.5V31.973Zm26.5-19.67v13.2h-33.076v33.128h39.599V12.303h-6.523Z",
    fill: "#6aa722",
    fillRule: "evenodd",
    "data-name": "Tracciato 318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.413 25.516-.057 33.12h39.766V51.93H97.118v-6.706h32.889v-6.184H97.06v-6.763h33.062v-6.762H90.413Z",
    fill: "#6aa722",
    fillRule: "evenodd",
    "data-name": "Tracciato 317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.96 25.503v33.128h6.576V32.127H84.56v-6.624h-39.6Z",
    fill: "#6aa722",
    fillRule: "evenodd",
    "data-name": "Tracciato 316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.021 25.503h6.47v33.128h-6.47V25.503z",
    fill: "#6aa722",
    fillRule: "evenodd",
    "data-name": "Rettangolo 1187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.321 25.503v33.128h6.582V32.127h26.5V58.63h6.523V25.503h-39.605Z",
    fill: "#6aa722",
    fillRule: "evenodd",
    "data-name": "Tracciato 315"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRendiLogoSmall);
export default __webpack_public_path__ + "static/media/rendiLogoSmall.41be05966ef134e57f1123ffdefbfd32.svg";
export { ForwardRef as ReactComponent };